import React from 'react';
import { GoPalLogo } from './GoPalLogo';

export function LoadingScreen() {
  return (
    <div
      className="flex items-center justify-center flex-col gap-4"
      style={{ height: '100vh', background: 'var(--bg)', color: 'var(--text)', fontFamily: 'var(--font)' }}
    >
      <GoPalLogo size={28} />
      <div className="text-sm text-muted">Loading…</div>
    </div>
  );
}
